<template>
  <div class="page-wrapper">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <div class="page-breadcrumb" v-if="devicehistory.data">
      <div class="row">
        <div class="col-md-5 align-self-center">
          <ol class="breadcrumb mb-0">
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: rem"
            >
              <router-link
                class="mylink"
                :to="'/devices/' + devicehistory.data.deviceTag + '/details'"
                >{{ $t("back-to") }}</router-link
              >
            </li>
          </ol>
        </div>

        <div class="col-md-7 align-self-center">
          <div class="d-flex align-items-start justify-content-end py-2">
            <button
              id="btnGroupDrop1"
              type="button"
              class="btn btn-primary"
              aria-expanded="false"
              @click="exportReport"
              :disabled="
                devicehistory.data &&
                devicehistory.data.subscription &&
                devicehistory.data.subscription.expired
              "
            >
              {{ $t("exp") }}
            </button>
            <div class="dropdown-menu" v-bind:class="{ show: exportShow }">
              <a
                class="dropdown-item mb-2"
                style="border: 1px solid rgba(0, 0, 0, 0.4); border-radius: 5px"
                @click.prevent="exportRecord('csv')"
                href="javascript:void(0)"
              >
                {{ $t("exp-csv") }}
              </a>
              <a
                href="javascript:void(0)"
                class="dropdown-item"
                style="border: 1px solid rgba(0, 0, 0, 0.4); border-radius: 5px"
                @click.prevent="exportRecord('pdf')"
                v-if="
                  devicehistory.data &&
                  devicehistory.data.subscription &&
                  devicehistory.data.subscription.active &&
                  !devicehistory.data.subscription.expired &&
                  devicehistory.data.type.toLowerCase() != 'loctrack'
                "
              >
                {{ $t("exp-pdf") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="px-4">
      <NotifcationBox :mssg="successMsg" :errorMssg="Errormssg" />
    </div>

    <div class="container-fluid pt-0">
      <h4 v-if="devicehistory.data" class="p-b-20">
        {{ this.devicehistory.data.settings.name }}
      </h4>
      <div class="card">
        <div class="card-body">
          <form @submit.prevent="onFilter" class="form-inline">
            <div style="margin: 1px 3px 1px 3px" class="col-lg-5 form-group">
              <label style="width: 3rem" class="mr-2"
                ><b>{{ $t("from") }}:</b>&nbsp;</label
              >
              <input
                type="date"
                name="startdate"
                class="form-control"
                v-model="startdate"
              />
              <input
                type="time"
                name="starttime"
                v-model="starttime"
                class="form-control"
                required
              />
            </div>

            <div style="margin: 1px 3px 1px 3px" class="col-lg-5 form-group">
              <label style="width: 3rem" class="mr-2"
                ><b>{{ $t("to") }}:</b>&nbsp;</label
              >
              <input
                type="date"
                name="date2"
                class="form-control"
                v-model="enddate"
              />
              <input
                type="time"
                name="endtime"
                v-model="endtime"
                class="form-control"
                required
              />
            </div>

            <div style="margin: 1px 3px 1px 3px" class="col-lg-1">
              <button
                type="submit"
                class="btn btn-primary mr-2"
                :disabled="
                  devicehistory.data &&
                  devicehistory.data.subscription &&
                  !devicehistory.data.subscription.active
                "
              >
                {{ $t("filter") }}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div v-if="devicehistory.stats && devicehistory.stats.length == 0">
        <div class="card">
          <div class="card-body p-4" align="center">
            <h4 class="mb-0 gray4">
              {{ $t("no-temp-humid") }}
            </h4>
          </div>
        </div>
      </div>
      <div
        v-else-if="
          devicehistory.data &&
          devicehistory.data.subscription &&
          !devicehistory.data.subscription.expired
        "
        class="row m-b-20"
      >
        <div
          class="col-lg-8"
          id="cardContainer"
          v-if="devicehistory.data.type.toLowerCase() != 'loctrack'"
        >
          <div class="card" style="height: 100%">
            <div
              v-if="mssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div class="card-body">
              <div
                class="d-flex justify-content-space-around col-md-8 col-lg-6 mx-auto"
                v-if="
                  devicehistory.data &&
                  (devicehistory.data.type == 'mote' ||
                    devicehistory.data.type === 'lora' ||
                    devicehistory.data.type === 'glog5' ||
                    devicehistory.data.type === 'gps-vt')
                "
              >
                <div class="btn-container">
                  <button
                    @click="showGraph('temp')"
                    :disabled="tempGraph == true"
                    id="graphselect"
                  >
                    {{ $t("temp") }}
                  </button>
                </div>
                <div class="btn-container">
                  <button
                    @click="showGraph('humi')"
                    :disabled="tempGraph == false"
                    id="graphselect"
                  >
                    {{ $t("humid") }}
                  </button>
                </div>
              </div>
              <div ref="content" id="my-node">
                <CombinedChart
                  :tempGraph="tempGraph"
                  :humiGraph="humiGraph"
                  :stats="devicehistory.points"
                  :hasTemp2="hasTemp2"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          :class="{
            'col-lg-4': devicehistory.data.type.toLowerCase() != 'loctrack',
            'col-lg-12': devicehistory.data.type.toLowerCase() == 'loctrack',
          }"
        >
          <div
            class="card"
            ref="mapContent"
            id="mapCont"
            style="height: 100%; min-height: 500px"
            v-if="!['lora', 'glog5'].includes(devicehistory.data.type.toLowerCase())"
          >
            <div class="card-body" id="map-image">
              <!-- <button v-on:click="reduceWidth">click</button> -->
              <DeviceRoutes :stats="devicehistory.stats" v-if="isRouteOne" />
              <DeviceRoutes2
                :stats="devicehistory.stats"
                v-else
                @no-direction="noDirection"
                :mapPoints="devicehistory.mapPoints"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        class="card"
        v-if="
          devicehistory.data &&
          devicehistory.data.subscription &&
          !devicehistory.data.subscription.expired
        "
      >
        <div class="card-body" style="max-height: 35rem; overflow-y: auto">
          <CombinedTable
            :stats="devicehistory.stats"
            :type="devicehistory.data.type.toLowerCase()"
            :paginationMeta="devicehistory.paginationMeta"
            :hasTemp2="hasTemp2"
            @pageChange="pageChange"
            :isFilter="isFilter"
          />
        </div>
      </div>
    </div>

    <footer class="footer text-center">
      &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
    </footer>
  </div>
</template>

<script
  src="https://maps.googleapis.com/maps/api/js?key=AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg&callback=initMap&v=weekly"
  defer
></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.3.2/jspdf.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/0.4.1/html2canvas.min.js"></script>
<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import jsPDF from "jspdf";

import html2canvas from "html2canvas";
import domtoimage from "dom-to-image";
import moment from "moment";
import vClickOutside from "v-click-outside";
import DeviceRoutes from "../../components/Devices/DeviceRoutes";
import DeviceRoutes2 from "../../components/Devices/DeviceRoutes2";
import CombinedTable from "../../components/Devices/CombinedTable";
import NotifcationBox from "../../components/NotificationBox.vue";
import axios from "axios";
import loadGoogleMapsApi from "load-google-maps-api";
// import CombinedChart from "../../components/Devices/CombinedChart";
// var mapDataUrl = "";

export default {
  name: "DeviceReport",
  data() {
    return {
      successMsg: "",
      mssg: "",
      Errormssg: "",
      startdate: "",
      starttime: "00:00",
      enddate: "",
      endtime: "23:59",
      isLoading: true,
      fullPage: true,
      tempGraph: true,
      humiGraph: false,
      exportShow: false,
      excursions: {},
      H: 85000,
      R: 8.31,
      mkt: 0,
      startLocation: "",
      endLocation: "",
      isRouteOne: false,
      isFilter: false,
    };
  },
  mounted() {
    this.enddate = new Date();
    this.startdate = new Date();
    this.startdate.setDate(new Date().getDate() - 1);
    this.enddate = moment(this.enddate).format("YYYY-MM-DD");
    this.startdate = moment(this.startdate).format("YYYY-MM-DD");
    this.getBusinessProfile();
    let period = {
      device: this.$route.params.device_id,
      startDate: `${this.startdate.replace(/-/g, "/")} ${this.starttime}`,
      endDate: `${this.enddate.replace(/-/g, "/")} ${this.endtime}`,
    };
    const params = {
      limit: 10,
      page: 1,
    };
    this.initialiseReport(period, params);
  },
  components: {
    Loading,
    DeviceRoutes,
    DeviceRoutes2,
    CombinedTable,
    CombinedChart: () =>
      import(
        /* webpackPrefetch: true */ "../../components/Devices/CombinedChart"
      ),
    NotifcationBox,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters(["devicehistory", "profile", "businessprofile"]),
    period() {
      return {
        device: this.$route.params.device_id,
        start: `${this.startdate.replace(/-/g, "/")} ${this.starttime}`,
        end: `${this.enddate.replace(/-/g, "/")} ${this.endtime}`,
      };
    },
    hasTemp2() {
      const flag = this.devicehistory?.data?.hasTemp2;
      if (typeof flag === "boolean") {
        return flag;
      }
      const candidates = Array.isArray(this.devicehistory?.points)
        ? this.devicehistory.points
        : Array.isArray(this.devicehistory?.stats)
        ? this.devicehistory.stats
        : [];
      return candidates.some(
        (reading) => reading && reading.temperature2 != null,
      );
    },
  },
  methods: {
    ...mapActions([
      "fetchDeviceDetails",
      "getDeviceHistory",
      "getBusinessProfile",
      "resetDeviceHistory",
      "fetchDeviceStats",
      "getDeviceReportByEmail",
    ]),
    convertToHoursAndMinutes(hours) {
      if (hours === "-") {
        return "-";
      }
      const totalMinutes = hours * 60;
      const hoursValue = Math.floor(totalMinutes / 60);
      const minutesValue = Math.round(totalMinutes % 60);

      const hasMins = minutesValue ? `${minutesValue} mins` : "";
      return `${hoursValue} hrs ${hasMins}`;
    },
    pageChange(params) {
      this.isLoading = true;
      let period = {
        device: this.$route.params.device_id,
        startDate: `${this.startdate.replace(/-/g, "/")} ${this.starttime}`,
        endDate: `${this.enddate.replace(/-/g, "/")} ${this.endtime}`,
      };

      this.initialiseReport(period, params);
    },
    initialiseReport(period, params) {
      // this.resetDeviceHistory();
      this.isLoading = true;
      this.getDeviceHistory({ period, params })
        .then(() => {
          this.isLoading = false;
          this.isFilter = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.isFilter = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    doGetDeviceStats() {
      const params = {
        limit: 10,
        page: 1,
      };
      let period = {
        device: this.$route.params.device_id,
        start: `${this.startdate.replace(/-/g, "/")} ${this.starttime}`,
        end: `${this.enddate.replace(/-/g, "/")} ${this.endtime}`,
      };
      this.fetchDeviceStats(period);
    },
    getAddress(dataToExport) {
      loadGoogleMapsApi({
        key: process.env.VUE_APP_GOOGLE_API_KEY,
        libraries: ["places", "drawing", "geometry"],
      }).then(async () => {
        let index = dataToExport.stats.length - 1;
        this.geocode(
          dataToExport.stats[0].latitude,
          dataToExport.stats[0].longitude,
          "start",
        );
        this.geocode(
          dataToExport.stats[index].latitude,
          dataToExport.stats[index].longitude,
          "end",
        );
      });
    },
    geocode(lat, lng, type) {
      const { google } = window;
      const geocoder = new google.maps.Geocoder();
      geocoder
        .geocode({ location: { lat, lng } })
        .then((response) => {
          if (type === "start") {
            this.startLocation =
              response.results[0].address_components[1].short_name;
          }
          if (type === "end") {
            this.endLocation =
              response.results[0].address_components[1].short_name;
          }
        })
        .catch((e) => {
          console.log(e);
          // alert(e.message);
        });
    },
    onFilter() {
      this.isRouteOne = false;
      this.mssg = "";
      const params = {
        limit: 10,
        page: 1,
      };
      // return console.log("get params:", params);
      if (this.startdate && this.enddate) {
        this.isFilter = true;
        // this.isLoading = true;
        // let period = {
        //   device: this.$route.params.device_id,
        //   start: `${this.startdate.replace(/-/g, "/")} ${this.starttime}`,
        //   end: `${this.enddate.replace(/-/g, "/")} ${this.endtime}`,
        // };
        // this.initialiseReport(period, params);
      } else {
        this.mssg = this.$t("selectPeriod");
      }
    },
    exportReport() {
      this.isLoading = true;
      const { imei } = this.devicehistory.data;
      const data = {
        deviceImei: imei,
        email: this.profile.email,
        startDate: `${this.startdate.replace(/-/g, "/")} ${this.starttime}`,
        endDate: `${this.enddate.replace(/-/g, "/")} ${this.endtime}`,
      };
      this.getDeviceReportByEmail(data)
        .then((res) => {
          this.successMsg = res.data.message;
          this.isLoading = false;
          this.isFilter = false;
          setTimeout(() => {
            this.successMsg = "";
          }, 10000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.isFilter = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          setTimeout(() => {
            this.Errormssg = "";
          }, 10000);
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    viewonMap(lat, lng) {
      window.open(`https://google.com/maps/search/${lat},${lng}`, "_blank");
    },
    closeExport() {
      if (this.exportShow == true) {
        this.exportShow = false;
      }
    },
    showGraph(type) {
      if (type == "temp") {
        this.tempGraph = true;
        this.humiGraph = false;
      }
      if (type == "humi") {
        this.humiGraph = true;
        this.tempGraph = false;
      }
    },
    noDirection() {
      this.isRouteOne = true;
    },
  },
};
</script>

<style scoped>
th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}
.btn-container {
  display: flex;
  justify-content: center;
  width: 50%;
}
#graphselect {
  background-color: inherit;
  border: none;
  color: #213e7a;
  padding: 7px 25px;
  border-radius: 30px;
  outline: none;
}
#graphselect:hover {
  background-color: #213e7a;
  color: white;
}
#graphselect:disabled,
#graphselect[disabled] {
  background-color: #dee2eb;
  color: #213e7a;
}
.mylink {
  color: #213e7a !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-decoration-color: #213e7a !important;
}
.tooltip {
  position: relative;
  display: inline-block;
  opacity: 1;
  cursor: default;
}
.tooltip .tooltiptext {
  width: 120px;
  bottom: 100%;
  left: 50%;
  margin-left: -60px; /* Use half of the width (120/2 = 60), to center the tooltip */
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1070;
}
/* .tooltip .tooltiptext::after {
  content: " ";
  position: absolute;
  top: 100%; 
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
} */
.tooltip:hover .tooltiptext {
  visibility: visible;
}
.reduce-width {
  width: 500px;
}
</style>

<i18n>
{
	"en": {
		"back-to": "Back to Device Details",
		"exp": "Export",
		"exp-csv": "Export as CSV",
		"exp-pdf": "Export as PDF",
		"feature": "This feature is only available with the premium plan",
		"from": "From",
		"no-temp-humid": "No Temperature/Humidity data available for this period",
		"to": "To"
	},
	"es": {
		"back-to": "Volver a Detalles del dispositivo",
		"exp": "Exportar",
		"exp-csv": "Exportar como CSV",
		"exp-pdf": "Exportar como PDF",
		"feature": "Esta función solo está disponible con el plan premium",
		"from": "Desde",
		"no-temp-humid": "No hay datos de temperatura / humedad disponibles para este período",
		"to": "a"
	},
	"fr": {
		"back-to": "Retour aux détails de l'appareil",
		"exp": "Exportation",
		"exp-csv": "Exporter au format CSV",
		"exp-pdf": "Exporter en PDF",
		"feature": "Cette fonctionnalité n'est disponible qu'avec le plan premium",
		"from": "De",
		"no-temp-humid": "Aucune donnée de température/humidité disponible pour cette période",
		"to": "à"
	},
	"sw": {
		"back-to": "Rudi kwa Maelezo ya Kifaa",
		"exp": "Uuzaji nje",
		"exp-csv": "Hamisha kama CSV",
		"exp-pdf": "Hamisha kama PDF",
		"feature": "Kipengele hiki kinapatikana kwa mpango wa malipo pekee",
		"from": "Kutoka",
		"no-temp-humid": "Hakuna data ya Halijoto/Unyevu inayopatikana kwa kipindi hiki",
		"to": "Kwa"
	}
}
</i18n>
